export default function TopicGrid({ title, kicker, topics = [], dense = false }) {
  return (
    <section data-testid="topic-grid" className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
        <div className="max-w-3xl mb-14">
          {kicker && (
            <div className="text-xs font-semibold tracking-[0.22em] text-[#10B981] uppercase mb-4">
              {kicker}
            </div>
          )}
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1F2937] tracking-tight text-balance">
            {title}
          </h2>
        </div>
        <div className={`grid gap-5 ${dense ? "sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4" : "sm:grid-cols-2 lg:grid-cols-3"}`}>
          {topics.map(({ icon: Icon, title: t, desc }, i) => (
            <div
              key={t}
              data-testid={`topic-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group relative bg-white border border-[#E5E7EB] rounded-xl p-6 hover:border-[#10B981] hover:shadow-[0_8px_30px_rgba(16,185,129,0.08)] transition-all duration-300"
              style={{ animationDelay: `${i * 30}ms` }}
            >
              <div className="h-11 w-11 rounded-lg bg-[#10B981]/10 grid place-items-center text-[#10B981] mb-4 group-hover:bg-[#10B981] group-hover:text-white transition-colors">
                <Icon className="h-5 w-5" strokeWidth={1.75} />
              </div>
              <h3 className="font-display text-lg font-semibold text-[#1F2937] mb-1">{t}</h3>
              {desc && <p className="text-sm text-[#4B5563] leading-relaxed">{desc}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
